import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Slider from '@material-ui/core/Slider';

const useStyles = makeStyles({
  root: {
    width: window.innerWidth,
  },
});


export default function TimeSlider() {
  const [time, setTime] = useState('');

  const classes = useStyles();

  const valuetext = value => {
    let left = Math.floor(value / 12);
    let float = value / 12 - left;
    let right = float * 60;
    setTime(`${left}:${Math.round(right)}`);
  }

  var d = new Date();
  var h = d.getHours();
  var m = d.getMinutes();

  return (
    <div className={classes.root + ' mobile-duty-calendar__slider--slider'}>
      <Typography>{time}</Typography>
      <Slider
        defaultValue={h * 12 + (m / 5)}
        getAriaValueText={valuetext}
        aria-labelledby="discrete-slider"
        step={1}
        min={0}
        max={12 * 24 - 1}
      />
    </div>
  );
}